import { render } from "./ProjectAddStakehoderDialog.vue?vue&type=template&id=180a5e8e"
import script from "./ProjectAddStakehoderDialog.vue?vue&type=script&lang=js"
export * from "./ProjectAddStakehoderDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__